import { ReactNode } from 'react';
import { BridgeStatusBanner } from '~/modules/TrafficInformation/BridgeStatusBanner';
import { InformationBanner } from '~/modules/InformationBanner';
import { OSBNavBar } from '~/modules/NavBar';
import { PreviewBar } from '~/components/PreviewBar';
import Footer from '~/modules/Footer';
import { Box } from '@oresundsbron/bridge-ui';

type DefaultLayoutProps = {
  children: ReactNode;
  preview?: boolean;
};

export function DefaultLayout({ children, preview }: DefaultLayoutProps) {
  return (
    <>
      <BridgeStatusBanner />
      <InformationBanner />
      <OSBNavBar />
      {preview && <PreviewBar />}
      <Box id="main-container" className="flex min-h-page flex-col">
        {children}
      </Box>
      <Footer />
    </>
  );
}
